import { supportedLocales, type Locale } from './translations';

export const defaultLocale: Locale = 'pt';

const intlLocaleMap: Record<Locale, string> = {
  pt: 'pt-BR',
  en: 'en-US',
};

export const getIntlLocale = (locale: Locale): string =>
  intlLocaleMap[locale] ?? intlLocaleMap[defaultLocale];

export const normalizeLocale = (value?: string | null): Locale | null => {
  if (!value) return null;
  const normalized = value.split('-')[0]?.toLowerCase();
  if (!normalized) return null;
  return supportedLocales.includes(normalized as Locale)
    ? (normalized as Locale)
    : null;
};

export const getBrowserLocale = (): Locale => {
  if (typeof navigator === 'undefined') return defaultLocale;
  const languages = navigator.languages?.length ? navigator.languages : [navigator.language];
  const matched = languages
    .map((language) => normalizeLocale(language))
    .find((locale): locale is Locale => Boolean(locale));
  return matched ?? defaultLocale;
};
